export default [
    {
        name: 'base',
        data: {},
        items:
        [
            { name: 'inputTexture', source: './assets/image1.jpg', type: 'texture' },
        ]
    }
]
